import React, { useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { fields } from 'src/components/utils/fields'
import { BufferService, LoadingContext, M_Button, M_MessageBoard, M_Table } from 'src/M_Components'

export const LumpSum = ({ roles, tablesOrder = [], onTablesOrderUpdate }) => {
    const { t } = useTranslation()
    const [open, setOpen] = useState(false)
    const [data, setData] = useState({})
    const [refresh, setRefresh] = useState(false)
    const ctx = useContext(LoadingContext)
    const lumpSumService = new BufferService('LumpSum')

    const LumpSumfields = [
        { display: t('Code'), required: true, code: 'Code', type: 'text' },
        { display: t('Name'), required: true, code: 'Name', type: 'text' },
        { display: t('ForeignName'), required: true, code: 'ForeignName', type: 'text' },
    ]

    const openCrud = (operation, passedData) => {
        const newObj = { operation }


        console.log(operation, passedData)

        if (operation === 'Create') {
            setOpen(true)
            setData({ ...newObj })
            return
        } else if (passedData) {
            setOpen(true)
            setData({ ...newObj, ...passedData })
            return
        } else {
            ctx.toastMessages('error', '', t("SelectedLine"))
        }
    }

    const save = () => {
        ctx.setIsLoad(true)
        switch (data['operation']) {
            case 'Create':
            case 'Copy':
                lumpSumService.post(data).then(res => {
                    ctx.setIsLoad(false)
                    if (res.name === 'AxiosError') {
                        console.log(res)
                        if (Array.isArray(res?.response?.data?.Errors)) {
                            ctx.toastMessages('error', res?.response?.data?.Errors.toString(), '')
                        } else {
                            ctx.toastMessages('error', res?.message, '')
                        }
                        return
                    }
                    setOpen(false)
                    setRefresh(true)
                    setData({})
                })
                break;
            default:
                lumpSumService.update(data.Id, data).then(res => {
                    ctx.setIsLoad(false)
                    if (res.name === 'AxiosError') {
                        if (res?.response?.data?.Errors && res.response.data.Errors.length > 0) {
                            ctx.toastMessages('error', (res.response.data.Errors), '')
                        } else {
                            ctx.toastMessages('error', res.message, '')
                        }
                        return
                    }
                    setOpen(false)
                    setRefresh(true)
                    setData({})
                })
                break;
        }
    }

    const close = () => {
        setOpen(false)
        setData({})
    }

    return (
        <>
            <M_Table
                entityName={'lumpSum'}
                removeContextItems={['Print']}
                rolePermissions={roles}
                tablesOrder={tablesOrder}
                onTablesOrderUpdate={onTablesOrderUpdate}
                pageUrl={'Lump Sum'}
                replaceFunctions={new Map([
                    ['Create', () => openCrud('Create')],
                    ['Edit', (e) => openCrud('Edit', e)],
                    ['Copy', (e) => openCrud('Copy', e)],
                    ['View', (e) => openCrud('View', e)]
                ])}
                refresh={refresh}
                setRefresh={setRefresh}
            />
            <M_MessageBoard
                open={open}
                title={t(data['operation']) + ' ' + t('LumpSum')}
                body={
                    <div style={{}}>
                        {LumpSumfields.map((field, index) => {
                            return (<div key={index}>{fields(data['operation'] === 'View' ? { ...field, type: 'disabled' } : field, index, data, setData, null, null, null, null, null, null, save, close)}</div>)
                        })}
                    </div>
                }
                footer={
                    <div style={{ display: 'flex' }}>
                        {data['operation'] !== 'View' && <M_Button
                            hoverEffect
                            width={20}
                            label={t("Save")}

                            onClick={() => save()}
                            backgroundColor={'var(--color-green)'}
                            labelColor={'var(--color-white)'}
                        />}
                        <M_Button
                            hoverEffect
                            width={15}
                            label={data['operation'] !== 'View' && t("Cancel") || t('Close')}
                            onClick={() => close()}
                            backgroundColor={'var(--color-red)'}
                            labelColor={'var(--color-white)'}
                        />
                    </div>
                }
            />
        </>
    )
}
